import { TaxonomyChild } from 'app/api/tag-queries';

/** Walk the taxonomy tree to find a node by ID. */
export const findNodeById = (nodes: TaxonomyChild[], targetId: string): TaxonomyChild | null => {
  for (const node of nodes) {
    if (node.id === targetId) return node;

    if (node.children.length > 0) {
      const found = findNodeById(node.children, targetId);
      if (found) return found;
    }
  }
  return null;
};
